import './calculationItemComponent.scss';
import {CalculationsIconsUtil} from "../../../utils/icons/CalculationsIconsUtil";

export class CalculationsItemComponent {

    constructor($scope, $log) {
        this.$scope = $scope;
        this.$log = $log;
        $log.debug('CalculationsItemComponent is mounting')
    }


    $onInit = () => {
        let calculation = this.calculation;
        calculation.icon_url = CalculationsIconsUtil.getIconUrl(calculation.name);
        this.$scope.calculation = calculation;
        this.$log.debug('CalculationsItemComponent has mounted')
    };


    static instance = {
        controller: ['$scope', '$log', CalculationsItemComponent],
        template: require('./calculationsItemComponent.html'),
        bindings: {
            calculation: '<'
        }
    }
}
